/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import './slideshows.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    $('.submenu-menu-toggle').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('open');
    });

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown'
    });

    $('.mobile-toggle').on("click keypress", function(e) {
        e.preventDefault();
        $(this).next().slideToggle( 'slow', function() {});
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    //Leadership Profile Popup - new design
    $('.js-profile-popup').magnificPopup({
        type:'inline',
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        removalDelay: 300,
        mainClass: 'mfp-fade',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close">Close</button>',
        callbacks: {
            elementParse: function(item) {
				var data = {
					action : 'get_profile',
					profileId : $(item.el).data('id')
				};
				$.post(site_data.WP_AJAX, data, function(response) {
					$('#profile-popup').append(response.html);
					$('#profile-popup .spinner').hide();
				});
			},
			close: function(){
				$('#profile-popup .spinner').show();
				$('#profile-popup .profile-details').remove();
			}
        },
    });


    //ORIGINAL DESIGN FUNCTIONALTY
    //open new window
    function openWindow(url) {
        var left = (screen.width - 570) / 2
        var top = (screen.height - 570) / 2
        var params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left
    
        window.open(url, 'NewWindow', params)
    }
    //SHARE
    $('body').on('click', '.windowable', function(e) {
        e.preventDefault()

        var $el = $(e.currentTarget)
        openWindow($el.attr('href'))
    });


    //open staff bio popup - original design
    $('.js-staff-popup').magnificPopup({
		type: 'inline',
        midClick: true,
        mainClass: 'mfp-fade'
	});

    //open location contact form
    $('.js-location-form-popup').magnificPopup({
        type: 'inline',
        preloader: false,
        focus: '#your_name',
        // When elemened is focused, some mobile browsers in some cases zoom in
        // It looks not nice, so we disable it:
        callbacks: {
            beforeOpen: function() {
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#your_name';
                }
            },
            close: function(){
                $('.contact-popup').removeClass('hidden');
                $('.contact-popoup-thankyou').addClass('hidden');
            }
        }
    });

    //footer columns
	$('.js-footer-nav1').responsiveNav({
		navType: 'dropdown',
		menuButtonSelector: '.js-nav-toggle1',
		dropdownSelector: '.js-footer-menu--1'
	});
    $('.js-footer-nav2').responsiveNav({
		navType: 'dropdown',
		menuButtonSelector: '.js-nav-toggle2',
		dropdownSelector: '.js-footer-menu--2'
	});
    $('.js-footer-nav3').responsiveNav({
		navType: 'dropdown',
		menuButtonSelector: '.js-nav-toggle3',
		dropdownSelector: '.js-footer-menu--3'
	});
    $('.js-footer-nav4').responsiveNav({
		navType: 'dropdown',
		menuButtonSelector: '.js-nav-toggle4',
		dropdownSelector: '.js-footer-menu--4'
	});

    const dialogBtns = document.querySelectorAll('.js-control-dialog');

    dialogBtns.forEach((btn, index) => {

        let showButton = btn;
        let dialog = document.querySelector('#' + btn.dataset.dialogTarget);
        let closeButton = dialog.querySelector('.popover__close');

        // "Show the dialog" button opens the dialog modally
        showButton.addEventListener("click", () => {
            dialog.showModal();
        });

        // "Close" button closes the dialog and removes focus
        closeButton.addEventListener("click", () => {
            dialog.close();
            showButton.blur(); // Remove focus from the button that opened the dialog
        });
    });

})(jQuery)
